import { render, staticRenderFns } from "./SellBusiness.vue?vue&type=template&id=480cf2b2&scoped=true&"
import script from "./SellBusiness.vue?vue&type=script&lang=js&"
export * from "./SellBusiness.vue?vue&type=script&lang=js&"
import style0 from "./SellBusiness.vue?vue&type=style&index=0&id=480cf2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cf2b2",
  null
  
)

export default component.exports